// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"stake-details_descriptionContainer__1TI6K","descriptionItem":"stake-details_descriptionItem__2Rftz"};